
<div class="mobile-header-container">

  <button mat-button (click)="toggleSideBar()" class="side-menu-button">

    <div class="side-menu-control" [ngClass]="{'open': isSidebarOpen}">
      <a class="nav-toggle" [ngClass]="{'open': isSidebarOpen}"
         href="javascript:void(0)">
        <span></span>
      </a>
    </div>

  </button>

  <div class="logo-title-row d-flex align-items-center" (click)="openHome()">
    <div class="main-logo-wrapper d-flex align-items-center">
      <img
        class="main-logo"
        [src]="'/assets/images/gesztenye_logo_white_filled.png'"
      />
    </div>
    <div class="logo-title">
      {{ "MAIN.APP_NAME" | translate }}
    </div>
  </div>
</div>

